import React from 'react'
import { useTranslation } from 'react-i18next'
import './style.css'    
const ScreenHeader = ({children, title}) => {

    const {t} = useTranslation()    
  return (
    <div className='screen-header'>
        <div>{t(title)}</div>
        {children}
    </div>
  )
}

export default ScreenHeader